module.exports = __webpack_public_path__ + "img/black_belt_move.8d0563a6.gif";